import { Component, DestroyRef, inject, input, OnInit, output, viewChild } from '@angular/core';
import { MatDatepickerModule, MatDateRangePicker } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIcon, provideIcons } from '@ng-icons/core';

import { heroCalendarDateRange } from '@ng-icons/heroicons/outline';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-date-range-picker',
  imports: [MatDatepickerModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, NgIcon],
  templateUrl: './date-range-picker.component.html',
  styleUrl: './date-range-picker.component.scss',
  providers: [provideIcons({heroCalendarDateRange}),]
})
export class DateRangePickerComponent implements OnInit {
  public form = input.required<FormGroup>();

  public calendarOpeningStatusEvent = output<boolean>();

  private picker = viewChild<MatDateRangePicker<any>>('picker');

  private destroyRef = inject(DestroyRef);
  
  ngOnInit(): void {
    this.checkOpenedCalendar();
    this.checkClosedCalendar();
  }

  private checkOpenedCalendar = () => {
    this.picker().openedStream.pipe(
      takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
      this.calendarOpeningStatusEvent.emit(true);
    })
  }
  
  private checkClosedCalendar = () => {
    this.picker().closedStream.pipe(
      takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
      this.calendarOpeningStatusEvent.emit(false);
    })
  }
}
